import React from 'react';

import { Close } from '@rover/icons';
import { Box, Button, Flex, Heading } from '@rover/kibble/core';

import type { DialogButtonProps, ModalCommonProps } from '../Modal.common';

import DialogButtons from './DialogButtons';

export type Props = DialogButtonProps &
  Omit<ModalCommonProps, 'isOpen'> & {
    headerId?: string;
    contentWrapperHeight?: string;
  };

export default function ModalContent({
  children,
  showCloseIcon,
  closeIconSize = 'default',
  headerText,
  headerId,
  headerSize = '300',
  headerProps = {},
  contentWrapperHeight,
  onRequestClose,
  ...buttonProps
}: Props): JSX.Element {
  return (
    <Flex flexDirection="column" width="100%" height={contentWrapperHeight}>
      {(headerText || showCloseIcon) && (
        <Flex
          flexDirection="row"
          justifyContent={headerText ? 'space-between' : 'flex-end'}
          alignItems="center"
          mb="4x"
          {...headerProps}
        >
          {headerText && (
            <Heading id={headerId} size={headerSize} m="0x">
              {headerText}
            </Heading>
          )}
          {showCloseIcon && (
            <Box ml="4x">
              <Button
                icon={Close}
                variant="flat"
                onClick={onRequestClose}
                size={closeIconSize}
                data-qa-id="modal-dismiss-button"
                data-testid="modal-dismiss-button"
                aria-label="Dismiss modal"
                sx={{ color: 'text.primary', '&:hover, &:focus': { color: 'text.primary' } }}
                circular
              />
            </Box>
          )}
        </Flex>
      )}
      <Box flex="1" flexBasis="auto" pt="0x">
        {children}
      </Box>
      <DialogButtons {...buttonProps} />
    </Flex>
  );
}
